import {FixFlickity} from "//www.okr.fr/cdn/shop/t/10/assets/helpers.js?v=55600738155002914361784882022";
export class LandingSliderSection extends HTMLElement {
  connectedCallback() {
    let that = this;
    this._attachListeners();

    if (document.readyState === 'complete') {
      this._initSlider();
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        that._initSlider();
      });
    }
  }

  _attachListeners() {
    let that = this;
    window.matchMedia('(min-width: 1024px)').addEventListener('change', () => {
      that._responsiveContent();
    })
  }

  /**
   * Init Sliders
   */
  _initSlider() {
    let that = this;

    //fix Flickity slider
    new FixFlickity();

    this.slider = new Flickity(this.querySelector('.page__landing-slider'), {
      cellAlign: 'left',
      groupCells: true,
      contain: true,
      prevNextButtons: true,
      pageDots: false,
      freeScroll: true,
      on: {
        ready: function () {
          // inject arrows
          this.prevButton.element.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="#262626" stroke-miterlimit="10" stroke-width="2" d="M0 8h14"/><path stroke="#262626" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2" d="M8 2l6 6-6 6"/></svg>';
          this.nextButton.element.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="#262626" stroke-miterlimit="10" stroke-width="2" d="M0 8h14"/><path stroke="#262626" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2" d="M8 2l6 6-6 6"/></svg>';
        }
      }
    });

    this.slider.resize();

    // Safety net for any late reflow (web fonts, etc.), still within the initial frame.
    requestAnimationFrame(function() {
      that.slider.resize();
    });
  }

  /**
   * Manage responsive content
   */
  _responsiveContent() {
    if (this.slider) {
      this.slider.resize();
    }
  }

}
try {
  window.customElements.define('landing-slider-section', LandingSliderSection);
} catch(e) {}